import { render, staticRenderFns } from "./OmbudsmanList.vue?vue&type=template&id=d8699fac&scoped=true&"
import script from "./OmbudsmanList.vue?vue&type=script&lang=js&"
export * from "./OmbudsmanList.vue?vue&type=script&lang=js&"
import style0 from "./OmbudsmanList.vue?vue&type=style&index=0&id=d8699fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8699fac",
  null
  
)

export default component.exports